import { ApiError } from './api'

/**
 * De omslag van een validatiefout draagt alleen een generieke titel ("Invalid entry");
 * wat er precies mis is staat in details. Die regel is het enige dat de invoerder
 * verder helpt, dus die wint.
 */
function detailMessage(error: ApiError): string | null {
  if (!Array.isArray(error.details)) return null
  const first = error.details.find(
    (item): item is { message: string } =>
      typeof item === 'object' && item !== null && typeof (item as { message?: unknown }).message === 'string',
  )
  return first?.message ?? null
}

export function errorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof ApiError)) return fallback
  return detailMessage(error) ?? (error.message || fallback)
}
